import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

// Get all community triggers
export const useGetAllCommunityTriggersQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_ALL_COMMUNITY_TRIGGERS],
    queryFn: async () => {
      const response = await api.get(API_ROUTES.GET_ALL_COMMUNITY_TRIGGERS);
      return response.data;
    },
  });

  return {
    triggers: data?.data ?? [],
    isPending,
    isError,
    error,
  };
};

// Get trigger by ID
export const useGetCommunityTriggerByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_COMMUNITY_TRIGGER, id],
    queryFn: () => api.get(API_ROUTES.GET_COMMUNITY_TRIGGER.replace(":id", id)),
    enabled: !!id,
  });

  return { data: data?.data ?? null, isPending, isError, error };
};

// Add new community trigger
export const useAddCommunityTriggerMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } = useMutation({
    mutationFn: (data) => api.post(API_ROUTES.ADD_COMMUNITY_TRIGGER, data),
    onSuccess: () => {
      showToast("success", "Trigger created successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries([API_ROUTES.GET_ALL_COMMUNITY_TRIGGERS]);
    },
  });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

// Update community trigger
export const useUpdateCommunityTriggerMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } = useMutation({
    mutationFn: (data) =>
      api.put(API_ROUTES.UPDATE_COMMUNITY_TRIGGER.replace(":id", data.id), data),
    onSuccess: () => {
      showToast("success", "Trigger updated successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries([API_ROUTES.GET_ALL_COMMUNITY_TRIGGERS]);
    },
  });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

// Delete community trigger
export const useDeleteCommunityTriggerMutation = () => {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isLoading, isSuccess, isPending } = useMutation({
    mutationFn: (id) => api.delete(API_ROUTES.DELETE_COMMUNITY_TRIGGER.replace(":id", id)),
    onSuccess: () => {
      showToast("success", "Trigger deleted successfully");
    },
    onSettled: () => {
      queryClient.invalidateQueries([API_ROUTES.GET_ALL_COMMUNITY_TRIGGERS]);
    },
  });

  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
